import React from 'react';
import { Invoice, Heading, Table, Link, Title, First, Second, Third, Forth, Icon } from './styles';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import { ICON_SIZE } from '../../../global/constants';

const InvoicesLoading: React.FC = () => {
  return (
    <Invoice>
      <Heading>
        <Title>Invoices</Title>
        <Link>See All</Link>
      </Heading>
      <Table>
        <thead>
          <tr className='row'>
            <th>
              <p>Invoice no</p>
              <SVGIcon name='line' width='1' height='21' viewBox='0 0 1 21' className='lineIcon' />
            </th>
            <th>
              <p>Invoice Date</p>
              <SVGIcon name='line' width='1' height='21' viewBox='0 0 1 21' className='lineIcon' />
            </th>
            <th>
              <p>Amount</p>
              <SVGIcon name='line' width='1' height='21' viewBox='0 0 1 21' className='lineIcon' />
            </th>
            <th>
              <p>Status</p>
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr className='first-row'>
            <td>
              <First className='first loading-animation'></First>
            </td>
            <td>
              <Second>
                <First className='top loading-animation' />
                <First className='bottom loading-animation' />
              </Second>
            </td>
            <td>
              <Third>
                <First className='top loading-animation' />
                <First className='bottom loading-animation' />
              </Third>
            </td>
            <td>
              <Forth>
                <First className='top loading-animation' />
              </Forth>
            </td>
            <td>
              <Icon>
                <SVGIcon
                  name='three-dots-horizontal-icon'
                  width={ICON_SIZE.LG}
                  height={ICON_SIZE.LG}
                  viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                  fill='var(--background-muted)'
                />
              </Icon>
            </td>
          </tr>
          <tr className='first-row'>
            <td>
              <First className='first loading-animation'></First>
            </td>
            <td>
              <Second>
                <First className='top loading-animation' />
                <First className='bottom loading-animation' />
              </Second>
            </td>
            <td>
              <Third>
                <First className='top loading-animation' />
                <First className='bottom loading-animation' />
              </Third>
            </td>
            <td>
              <Forth>
                <First className='top loading-animation' />
              </Forth>
            </td>
            <td>
              <Icon>
                <SVGIcon
                  name='three-dots-horizontal-icon'
                  width={ICON_SIZE.LG}
                  height={ICON_SIZE.LG}
                  viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                  fill='var(--background-muted)'
                />
              </Icon>
            </td>
          </tr>
          <tr className='first-row'>
            <td>
              <First className='first loading-animation'></First>
            </td>
            <td>
              <Second>
                <First className='top loading-animation' />
                <First className='bottom loading-animation' />
              </Second>
            </td>
            <td>
              <Third>
                <First className='top loading-animation' />
                <First className='bottom loading-animation' />
              </Third>
            </td>
            <td>
              <Forth>
                <First className='top loading-animation' />
              </Forth>
            </td>
            <td>
              <Icon>
                <SVGIcon
                  name='three-dots-horizontal-icon'
                  width={ICON_SIZE.LG}
                  height={ICON_SIZE.LG}
                  viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                  fill='var(--background-muted)'
                />
              </Icon>
            </td>
          </tr>
          <tr className='first-row'>
            <td>
              <First className='first loading-animation'></First>
            </td>
            <td>
              <Second>
                <First className='top loading-animation' />
                <First className='bottom loading-animation' />
              </Second>
            </td>
            <td>
              <Third>
                <First className='top loading-animation' />
                <First className='bottom loading-animation' />
              </Third>
            </td>
            <td>
              <Forth>
                <First className='top loading-animation' />
              </Forth>
            </td>
            <td>
              <Icon>
                <SVGIcon
                  name='three-dots-horizontal-icon'
                  width={ICON_SIZE.LG}
                  height={ICON_SIZE.LG}
                  viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                  fill='var(--background-muted)'
                />
              </Icon>
            </td>
          </tr>
          <tr className='first-row'>
            <td>
              <First className='first loading-animation'></First>
            </td>
            <td>
              <Second>
                <First className='top loading-animation' />
                <First className='bottom loading-animation' />
              </Second>
            </td>
            <td>
              <Third>
                <First className='top loading-animation' />
                <First className='bottom loading-animation' />
              </Third>
            </td>
            <td>
              <Forth>
                <First className='top loading-animation' />
              </Forth>
            </td>
            <td>
              <Icon>
                <SVGIcon
                  name='three-dots-horizontal-icon'
                  width={ICON_SIZE.LG}
                  height={ICON_SIZE.LG}
                  viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                  fill='var(--background-muted)'
                />
              </Icon>
            </td>
          </tr>
          <tr className='first-row'>
            <td>
              <First className='first loading-animation'></First>
            </td>
            <td>
              <Second>
                <First className='top loading-animation' />
                <First className='bottom loading-animation' />
              </Second>
            </td>
            <td>
              <Third>
                <First className='top loading-animation' />
                <First className='bottom loading-animation' />
              </Third>
            </td>
            <td>
              <Forth>
                <First className='top loading-animation' />
              </Forth>
            </td>
            <td>
              <Icon>
                <SVGIcon
                  name='three-dots-horizontal-icon'
                  width={ICON_SIZE.LG}
                  height={ICON_SIZE.LG}
                  viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                  fill='var(--background-muted)'
                />
              </Icon>
            </td>
          </tr>
          <tr className='first-row'>
            <td>
              <First className='first loading-animation'></First>
            </td>
            <td>
              <Second>
                <First className='top loading-animation' />
                <First className='bottom loading-animation' />
              </Second>
            </td>
            <td>
              <Third>
                <First className='top loading-animation' />
                <First className='bottom loading-animation' />
              </Third>
            </td>
            <td>
              <Forth>
                <First className='top loading-animation' />
              </Forth>
            </td>
            <td>
              <Icon>
                <SVGIcon
                  name='three-dots-horizontal-icon'
                  width={ICON_SIZE.LG}
                  height={ICON_SIZE.LG}
                  viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                  fill='var(--background-muted)'
                />
              </Icon>
            </td>
          </tr>
          <tr className='first-row'>
            <td>
              <First className='first loading-animation'></First>
            </td>
            <td>
              <Second>
                <First className='top loading-animation' />
                <First className='bottom loading-animation' />
              </Second>
            </td>
            <td>
              <Third>
                <First className='top loading-animation' />
                <First className='bottom loading-animation' />
              </Third>
            </td>
            <td>
              <Forth>
                <First className='top loading-animation' />
              </Forth>
            </td>
            <td>
              <Icon>
                <SVGIcon
                  name='three-dots-horizontal-icon'
                  width={ICON_SIZE.LG}
                  height={ICON_SIZE.LG}
                  viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                  fill='var(--background-muted)'
                />
              </Icon>
            </td>
          </tr>
        </tbody>
      </Table>
    </Invoice>
  );
};

export default InvoicesLoading;
